import React, { useState } from 'react'
import { Formik } from 'formik'
import './DeleteAccountModal.scss'
const DeleteAccountForm = () => {
  const [isWaiting, setIsWaiting] = useState(false) // use this to render a visual indicator

  const handleDeleteAccount = () => {
    setIsWaiting(true)
  }

  return (
    <Formik
      onSubmit={values => {
        handleDeleteAccount()
      }}
    >
      {({ values, handleSubmit, setFieldValue, errors, touched }) => {
        return (
          <form onSubmit={handleSubmit} id="Delete Account">
            <input type="submit" value="Yes, delete my account" />
          </form>
        )
      }}
    </Formik>
  )
}

const DeleteAccountModal = () => {
  const modal_context = modal_context || {}
  const { modalContent } = modal_context || {}
  return (
    <div className="modal-delete-account">
      <div className="modal-header">
        <h3>Are you absolutely sure?</h3>
      </div>
      <div className="content-body">
        <DeleteAccountForm />
      </div>
    </div>
  )
}

export default DeleteAccountModal
